import { unsafeCSS, type CSSResult } from 'lit';
import rem from '@loadsmart/miranda-toolset/dist/to-rem';

/**
 * Convert the provided value from px to rem as lit's `CSSResult`.
 *
 * @example
 * // Considering 1rem = 16px
 * toRem(10); // returns '0.625rem'
 * toRem('16px'); // returns '1rem'
 *
 * @param {number | string} value - value, in pixels, to convert.
 * @param {number} base - value, in pixels, to be considered for 1rem.
 * @returns {CSSResult}
 */
function toRem(value: number | string, base?: number): CSSResult {
	return unsafeCSS(rem(value, base));
}

export default toRem;
